import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { COLORS } from '../constants/styles';

const ARROW_CONTAINER_HEIGHT_PX = 30;

const styles = {
    arrowContainer: {
        height: `${ARROW_CONTAINER_HEIGHT_PX}px`,
        width: '25px',
        position: 'absolute',
        top: `calc(50% - ${ARROW_CONTAINER_HEIGHT_PX / 2}px)`,
        left: 0,
        zIndex: '1',
        borderRadius: '0 8px 8px 0',
        backgroundColor: COLORS.GRAY_MERCURY,
        boxShadow: '0 2px 4px 0 rgba(0,0,0,0.5)',
        padding: '6px 8px',
        cursor: 'pointer',
        opacity: '1',
        transition: 'opacity .25s ease-in-out',
    },
    arrow: {
        border: `solid ${COLORS.BLACK}`,
        borderWidth: '0 3px 3px 0',
        display: 'inline-block',
        padding: '3px',
        transform: 'rotate(135deg)',
        WebkitTransform: 'rotate(135deg)',
    },
    rightArrow: {
        transform: 'rotate(-45deg)',
        WebkitTransform: 'rotate(-45deg)',
    },
    rightContainer: {
        borderRadius: '8px 0 0 8px',
        left: 'inherit',
        right: 0,
    },
    hidden: {
        opacity: '0',
        cursor: 'auto',
        pointerEvents: 'none',
    },
};

export default class CarouselArrow extends Component {
    static propTypes = {
        isHidden: PropTypes.bool,
        isNext: PropTypes.bool,
        onClick: PropTypes.func.isRequired,
    };

    render() {
        const { isNext, isHidden, onClick } = this.props;
        let containerStyles = styles.arrowContainer;
        let arrowStyles = styles.arrow;

        if (isNext) {
            containerStyles = { ...styles.arrowContainer, ...styles.rightContainer };
            arrowStyles = { ...styles.arrow, ...styles.rightArrow };
        }

        if (isHidden) {
            containerStyles = { ...containerStyles, ...styles.hidden };
        }

        return (
            <div style={containerStyles} onClick={onClick}>
                <i style={arrowStyles}></i>
            </div>
        );
    }
}
